import { RouteRecordRaw, RouterView } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "publicexam",
    name: "publicexamIndex",
    component: () => import("@/views/publicexam/index.vue")
  }
];
export default routes;
